import React from "react";
import styled, { css } from "styled-components";
import { Icon, MenuItem, Select } from "@material-ui/core";

import { SearchBar } from "js/react/views/AddSlide/Panes/Components/SearchBox";
import { IconMenu } from "js/react/components/UiComponents";
import { app } from "js/namespaces";
import { themeColors } from "js/react/sharedStyles";
import { KeyboardArrowDown as KeyboardArrowDownIcon } from "@material-ui/icons";

const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 0 0 24px;
`;

const TitleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    min-height: 50px;
`;

const Title = styled.div`
    color: #000;
    font-family: "Source Sans Pro";
    font-size: 23px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: 0.5px;

    .dark-mode & {
        color: #ccc;
    }
`;

const TitleActions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
`;

const StyledSearchBar = styled(SearchBar)`
    width: 100%;
    padding: 6px 10px;
    margin: 0;
    gap: 10px;
    min-height: 40px;
    border: 1px solid #d7dce3;
    border-radius: 100px;
    background: white;
    box-sizing: border-box;

    .MuiIcon-root {
        color: ${themeColors.ui_blue};
    }

    .clear-search {
        right: 12px;
        margin-right: 0;
    }

    input[type="text"] {
        width: 100%;
        margin: 0;
        font-size: 16px;
        font-weight: 500;
        padding-right: 24px;
    }

    input[type="text"]::placeholder {
        color: #999;
        font-family: "Source Sans Pro";
        font-size: 16px;
        font-weight: 400;
        line-height: 150%;
    }
`;

const FilterRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    min-height: 40px;
`;

const FilterGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
`;

const ControlGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
`;

const SelectFrame = styled.div`
    min-width: 92px;
    height: 36px;
    display: flex;
    align-items: center;
    background: white;
`;

const StyledSelect = styled(Select)`
    &&& {
        width: 100%;
        color: ${themeColors.darkGray};
    }

    .MuiSelect-select {
        text-align: center;
        font-family: "Source Sans Pro";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 125%;
        letter-spacing: -0.32px;
        text-transform: none;
    }
    .MuiSelect-icon {
        color: #000;
    }
`;

const iconMenuStyles = css`
    &&& {
        padding: 0;

        .bai-icon,
        .material-icons,
        .MuiIcon-root,
        .MuiSvgIcon-root {
            color: #000;
        }
    }
`;

const StyledIconMenu = styled(IconMenu)`
    ${iconMenuStyles};
`;

export function TeamResourcesHeaderFilter({ value, onChange, options }) {
    return (
        <SelectFrame>
            <StyledSelect
                value={value}
                onChange={onChange}
                disableUnderline
                IconComponent={KeyboardArrowDownIcon}

            >
                {options.map(option => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.name}
                    </MenuItem>
                ))}
            </StyledSelect>
        </SelectFrame>
    );
}

export function TeamResourcesPaneHeader({
    title,
    action,
    onSearch,
    searchPlaceholder = "",
    filterContent = null,
    sortOptions = [],
    sort = null,
    onSetSort = null,
    showControls = false,
}) {
    const showFilterRow = !!filterContent || showControls;
    const handleSearch = value => {
        onSearch && onSearch(value);
    };

    return (
        <Header>
            <TitleRow>
                <Title>{title}</Title>
                <TitleActions>{action}</TitleActions>
            </TitleRow>

            <StyledSearchBar
                showIcon
                placeholder={searchPlaceholder}
                onSearch={handleSearch}
                $isMobile={app.isMobileOrTablet}
            />

            {showFilterRow && (
                <FilterRow>
                    <FilterGroup>{filterContent}</FilterGroup>
                    {showControls && (
                        <ControlGroup>
                            {sortOptions.length > 0 && (
                                <StyledIconMenu icon="sort" iconColor="#000" $isMobile={app.isMobileOrTablet}>
                                    {sortOptions.map(option => (
                                        <MenuItem
                                            key={option.value}
                                            selected={(sort?.field ?? sort?.value) === option.value}
                                            onClick={() => onSetSort && onSetSort({
                                                field: option.value,
                                                reverse: option.reverse
                                            })}
                                        >
                                            {option.icon && <Icon>{option.icon}</Icon>}
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </StyledIconMenu>
                            )}
                        </ControlGroup>
                    )}
                </FilterRow>
            )}
        </Header>
    );
}
